import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectServiceAll
} from "~/components/Forms";
import {useEffect} from "react";

function RequestDemoFormEdit({item, onHandleSubmit})
{
	const initialValues = {
		url: ''
	}

	const validationSchema = Yup.object().shape({
		url: Yup.string().required('Bạn chưa nhập link hình ảnh demo'),
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if (item?.id) {
			initialValues.url = item.url;
		}
		reset(initialValues);
	}, [item?.id]);

	const onSubmit = async (data) =>
	{
		await onHandleSubmit(item, data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Yêu cầu</p>
			<Controller control={control} name="url" render={({field}) => (
				<InputField label="Link hình ảnh demo" errors={errors} {...field} />
			)}/>
			<hr/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật yêu cầu</Button>
			</div>
		</form>
	)
}

export default RequestDemoFormEdit;